import { createContext, useState, ReactNode } from "react";

// 状態と状態更新用関数を格納する型を定義
interface ViewContextType {
  isName: boolean;
  setIsName: (value: boolean) => void;
  visible: boolean;
  setVisible: (value: boolean) => void;
  isAlertPrioritized: boolean;
  setIsAlertPrioritized: (value: boolean) => void;
  isAlertPriorityVisible: boolean;
  setIsAlertPriorityVisible: (value: boolean) => void;
}

// コンテキストを作成
export const ViewContext = createContext<ViewContextType | undefined>(
  undefined
);

export function ViewProvider({ children }: { children: ReactNode }) {
  const [isName, setIsName] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isAlertPrioritized, setIsAlertPrioritized] = useState(false);
  const [isAlertPriorityVisible, setIsAlertPriorityVisible] = useState(false);

  return (
    <ViewContext.Provider
      value={{
        isName: isName,
        setIsName: setIsName,
        visible,
        setVisible,
        isAlertPrioritized,
        setIsAlertPrioritized,
        isAlertPriorityVisible,
        setIsAlertPriorityVisible,
      }}
    >
      {children}
    </ViewContext.Provider>
  );
}
